import { alpha, Stack, Text } from '@ltvco/refresh-lib/theme';
import { AutoAwesome } from '@mui/icons-material';

import { Answer } from 'api/communityBuzz/interfaces';

import { BEENVERIFIED_AI_USERNAME, isAIContributor } from './constants';
import { calculateTimeSince } from './utils';

interface AnswerDetailsProps {
  answer?: Answer;
}

export const AnswerDetails = ({ answer }: AnswerDetailsProps) => {
  const isBeenverifiedAI = isAIContributor(answer?.source, answer?.username);

  return (
    <Stack
      width="100%"
      mb={2}
      p={2}
      sx={(theme) => ({
        backgroundColor: isBeenverifiedAI
          ? alpha(theme.palette.primary.main, 0.035)
          : 'transparent',
        borderBottom: `1px solid ${theme.palette.divider}`,
      })}
    >
      <Stack width="100%" spacing={1}>
        <Stack alignItems="center" direction="row" spacing={1}>
          {isBeenverifiedAI && <AutoAwesome sx={{ color: 'primary.main' }} />}
          <Text variant="h5">
            {isBeenverifiedAI ? BEENVERIFIED_AI_USERNAME : answer?.username}
          </Text>
          <Text variant="body2" color="text.secondary">
            {calculateTimeSince(answer?.created_at)}
          </Text>
        </Stack>
        <Text variant="body2" mb={0}>
          {answer?.body_md}
        </Text>
      </Stack>
    </Stack>
  );
};
